// extracted by mini-css-extract-plugin
export default {"icon":"EditFeedSettingButton_icon__1v3Eh"};